<template>
    <div class="custom-error">
        <i class="vcore_icon icon-warning" />
        {{ error }}
    </div>
</template>

<script>
export default {
  name: "CustomError",
  props: {
      error: String
  }
};
</script>

<style lang="scss" scoped>
.custom-error {
  font-size: 12px;
  line-height: 18px;
  color: #e30000;
  margin-top: 4px;
}
</style>
